import {Exclude, Expose} from 'class-transformer';

@Exclude()
export class AgreementGroupApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
